import script from "./Privacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Privacy.vue?vue&type=script&lang=ts&setup=true"

import "./Privacy.vue?vue&type=style&index=0&id=66453a9d&scoped=true&lang=stylus"
script.__scopeId = "data-v-66453a9d"

export default script